import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import router from './router'

const base = axios.create({
  // baseURL: "http://localhost:4000"
  baseURL: "https://stats-api.grayriver.dk"
});

// Add response interceptor to cache recipes in localStorage
base.interceptors.response.use(
  (response) => {
    // Cache recipe data in localStorage for offline access
    if (response.config.url.includes('/recipe/all')) {
      localStorage.setItem('cached_recipes', JSON.stringify(response.data));
      localStorage.setItem('cached_recipes_time', Date.now().toString());
    }
    if (response.config.url.includes('/recipe/findById')) {
      const cachedRecipes = JSON.parse(localStorage.getItem('cached_recipe_details') || '{}');
      const id = new URL(response.config.url, response.config.baseURL).searchParams.get('id');
      cachedRecipes[id] = response.data;
      localStorage.setItem('cached_recipe_details', JSON.stringify(cachedRecipes));
    }
    return response;
  },
  (error) => {
    // On network error, try to return cached data
    if (!error.response) {
      const url = error.config.url;
      if (url.includes('/recipe/all')) {
        const cached = localStorage.getItem('cached_recipes');
        if (cached) {
          return { data: JSON.parse(cached) };
        }
      }
      if (url.includes('/recipe/findById')) {
        const id = new URL(url, error.config.baseURL).searchParams.get('id');
        const cachedDetails = JSON.parse(localStorage.getItem('cached_recipe_details') || '{}');
        if (cachedDetails[id]) {
          return { data: cachedDetails[id] };
        }
      }
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = base;
Vue.config.productionTip = false

// Unregister any existing service workers to fix reload loop
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('SW unregistered');
    }
  });
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
